// 부품 카테고리 (대분류 → 중분류 → 소분류). 소분류가 없으면 빈 배열.
export const PART_CATEGORIES = {
  "저항": {
    "칩저항(SMD)": [],
    "리드저항(TH)": [],
    "가변저항": [],
    "어레이/네트워크": [],
    "션트/전류센싱": [],
  },
  "커패시터": {
    "세라믹(MLCC)": [],
    "전해": [],
    "탄탈": [],
    "필름": [],
    "슈퍼캐패시터": [],
  },
  "인덕터/코일": {
    "파워인덕터": [],
    "페라이트비드": [],
    "공통모드초크": [],
  },
  "다이오드": {
    "일반정류": [],
    "쇼트키": [],
    "제너": [],
    "TVS/ESD": [],
    "브리지": [],
    "LED": [],
  },
  "트랜지스터": {
    "BJT": ["NPN", "PNP"],
    "MOSFET": ["N채널", "P채널"],
    "IGBT": [],
    "디지털TR": [],
  },
  "IC": {
    "MCU/MPU": ["8bit", "16bit", "32bit"],
    "OP앰프/비교기": [],
    "레귤레이터": ["LDO", "DC-DC", "레퍼런스"],
    "로직": ["게이트", "버퍼/드라이버", "카운터/레지스터"],
    "인터페이스": ["RS-232", "RS-485", "CAN", "USB", "I2C/SPI"],
    "메모리": ["EEPROM", "Flash", "SRAM"],
    "ADC/DAC": [],
    "전원관리/PMIC": [],
    "모터드라이버": [],
    "센서IC": [],
  },
  "커넥터": {
    "핀헤더": [],
    "박스헤더": [],
    "터미널블록": [],
    "USB": [],
    "FFC/FPC": [],
    "원형/방수": [],
  },
  "스위치/릴레이": {
    "택트스위치": [],
    "슬라이드/토글": [],
    "딥스위치": [],
    "릴레이": [],
  },
  "크리스탈/오실레이터": {
    "크리스탈": [],
    "오실레이터": [],
    "레조네이터": [],
  },
  "센서": {
    "온도/습도": [],
    "가속도/자이로": [],
    "전류/전압": [],
    "광/근접": [],
    "기타": [],
  },
  "전원/기타": {
    "퓨즈": [],
    "배리스터/서지": [],
    "배터리/홀더": [],
    "방열/기구": [],
    "기타": [],
  },
};

export const CAT1_LIST = Object.keys(PART_CATEGORIES);
export const cat2List = (c1) => (c1 && PART_CATEGORIES[c1] ? Object.keys(PART_CATEGORIES[c1]) : []);
export const cat3List = (c1, c2) =>
  c1 && c2 && PART_CATEGORIES[c1] && PART_CATEGORIES[c1][c2] ? PART_CATEGORIES[c1][c2] : [];
